"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.ToastNotification = void 0;

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/object/keys"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));

var _jsxRuntime = require("react/jsx-runtime");

var _react = require("@fluentui/react");

var _AppBar = require("@uifabric/portal-ux/lib/components/AppBar/AppBar.classNames");

var React = _interopRequireWildcard(require("react"));

var _reactToastify = require("react-toastify");

var _stylingConstants = require("../../styling/stylingConstants");

var _INotification = require("../models/INotification");

// cspell:ignore toastify
var toastStyles = require('./Toast.scoped.scss');

var ToastNotification = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(ToastNotification, _React$Component);

  var _super = (0, _createSuper2.default)(ToastNotification);

  function ToastNotification(props) {
    var _this;

    (0, _classCallCheck2.default)(this, ToastNotification);
    _this = _super.call(this, props);

    _this.showToastNotification = function (notification) {
      var correlationId = notification.correlationId,
          severity = notification.severity,
          localizableMessage = notification.localizableMessage,
          autoClose = notification.autoClose;
      var theme = (0, _react.getTheme)();
      (0, _reactToastify.style)({
        colorInfo: theme.palette.blue,
        colorWarning: theme.palette.yellow,
        colorError: theme.palette.red,
        colorSuccess: theme.palette.green,
        TOP_RIGHT: {
          top: _AppBar.APP_BAR_PIXEL_HEIGHT + _stylingConstants.gridUnit,
          right: _stylingConstants.gridUnit
        }
      });

      var message = localizableMessage && _this.props.t && _this.props.t(localizableMessage.key, localizableMessage.options);

      var hasParameters = (0, _keys.default)(localizableMessage.options || {}).length > 0;
      var dateTime = new Date();
      var toastContent = message;
      toastContent = /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: hasParameters ? 'ms-pii' : '',
          children: message
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: toastStyles.unexpectedErrorDate,
          children: [" ", dateTime.toUTCString()]
        }), correlationId ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: toastStyles.unexpectedErrorCorrelationId,
          children: [" ", correlationId]
        }) : null]
      });
      var toastOptions = {
        className: 'ms-pii',
        autoClose: autoClose
      };

      switch (severity) {
        case _INotification.NotificationSeverity.info:
          _reactToastify.toast.info(toastContent, toastOptions);

          break;

        case _INotification.NotificationSeverity.warn:
          _reactToastify.toast.warn(toastContent, toastOptions);

          break;

        case _INotification.NotificationSeverity.success:
          _reactToastify.toast.success(toastContent, toastOptions);

          break;

        case _INotification.NotificationSeverity.error:
          _reactToastify.toast.error(toastContent, toastOptions);

          break;

        case _INotification.NotificationSeverity.userError:
          _reactToastify.toast.error(toastContent, toastOptions);

          break;
      }
    };

    _this.state = {
      lastDisplayedNotification: null
    };
    return _this;
  }

  (0, _createClass2.default)(ToastNotification, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(props) {
      var lastReceivedNotification = this.state.lastDisplayedNotification;

      if (props.notification && (!lastReceivedNotification || props.notification.id !== lastReceivedNotification.id) && props.notification.type === _INotification.NotificationType.toast) {
        this.showToastNotification(props.notification);
        this.setState({
          lastDisplayedNotification: props.notification
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactToastify.ToastContainer, {});
    }
  }]);
  return ToastNotification;
}(React.Component);

exports.ToastNotification = ToastNotification;